import ChatMessageContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ChatMessageContent";

export default class ChatMessage {
    /**
     * @constructor
     * @param {ChatMessageContent} content 
     * @param {boolean} fromPlayer 
     * @param {number} time 
     * @param {string} npcId 
     * @param {boolean} isRead 
     */
    constructor(content, fromPlayer, time, npcId = null, isRead = false) {
        this._content = content;
        this._fromPlayer = fromPlayer;
        this._time = time;
        this._npcId = npcId;
        this._isRead = isRead;
    }

    get content() {
        return this._content;
    }

    get npcId() {
        return this._npcId;
    }

    get fromPlayer() {
        return this._fromPlayer;
    }

    get time() {
        return this._time;
    }

    get isRead() {
        return this._isRead;
    }

    markAsRead() {
        this._isRead = true;
    }
}